import {Action, Selector, State, StateContext} from '@ngxs/store';
import {
  SetPaymentKey,
  SetPaymentStepAfripay,
  SetPaymentStepCard,
  SetPaymentStepMobicred,
  SetPaymentStepOtt,
  SetPaymentStepSecureEft,
  SetSessionStorage
} from 'src/app/components/shared/map.actions';
import {Injectable} from '@angular/core';
import {Session} from 'src/app/interfaces/session-data';

// TODO: Below is Done badly, fix later - make a payment model that holds all payment key/value pairs, rather than doing 2 models like below...
export class PaymentKeyStateModel {
  paymentkey: string;
  paymentmethod: string;
}

export class MapStateModel {
  sessionStorage: Session;
}

export class PaymentStepStateModel {
  secureEft: string;
  card: string;
  mobicred: string;
  ottVoucher: string;
  afripay: string;
}

@State<PaymentKeyStateModel>({
  name: 'key',
  defaults: {
    paymentkey: '',
    paymentmethod: 'STEP_ONE'
  }
})

@State<MapStateModel>({
  name: 'map',
  defaults: {
    sessionStorage: sessionStorage.getItem('sessionData') && sessionStorage.getItem('sessionData') !== 'undefined' ? JSON.parse(sessionStorage.getItem('sessionData')) : {},
  }
})

@State<PaymentStepStateModel>({
  name: 'step',
  defaults: {
    secureEft: 'STEP_ONE',
    card: 'STEP_ONE',
    mobicred: 'STEP_ONE',
    ottVoucher: 'STEP_ONE',
    afripay: 'STEP_ONE',
  }
})

@Injectable()
export class PaymentKeyState {

  @Selector()
  static key(state: PaymentKeyStateModel) {
    return state;
  }

  constructor() {}

  @Action(SetPaymentKey)
  setPaymentKey({ patchState }: StateContext<PaymentKeyStateModel>, { payload }: SetPaymentKey) {
    patchState({
      paymentkey: payload
    });
  }
}

@Injectable()
export class MapState {
  @Selector()
  static sessionStorage(state: MapStateModel) {
    return state.sessionStorage;
  }

  constructor() {}

  @Action(SetSessionStorage)
  login({ patchState }: StateContext<MapStateModel>, { payload }: SetSessionStorage ) {
    patchState({
      sessionStorage: payload,
    });

    sessionStorage.setItem('sessionData', JSON.stringify(payload));

  }

}

@Injectable()
export class PaymentStepState {

  @Selector()
  static key(state: PaymentStepStateModel) {
    return state;
  }

  constructor() {}

  @Action(SetPaymentStepOtt)
  setOttPaymentStep({ patchState }: StateContext<PaymentStepStateModel>, { payload }: SetPaymentStepOtt) {
    patchState({
      ottVoucher: payload
    });
  };
  @Action(SetPaymentStepAfripay)
  setAfripayPaymentStep({ patchState }: StateContext<PaymentStepStateModel>, { payload }: SetPaymentStepAfripay) {
    patchState({
      afripay: payload
    });
  }
  @Action(SetPaymentStepCard)
  setCardPaymentStep({ patchState }: StateContext<PaymentStepStateModel>, { payload }: SetPaymentStepCard) {
    patchState({
      card: payload
    });
  }
  @Action(SetPaymentStepMobicred)
  setMobicredPaymentStep({ patchState }: StateContext<PaymentStepStateModel>, { payload }: SetPaymentStepMobicred) {
    patchState({
      mobicred: payload
    });
  }
  @Action(SetPaymentStepSecureEft)
  setSecureEftPaymentStep({ patchState }: StateContext<PaymentStepStateModel>, { payload }: SetPaymentStepSecureEft) {
    patchState({
      secureEft: payload
    });
  }
}
